/**
 * Accepts a focal point object of key value pairs for "leftPercentage" and "topPercentage" position percent values
 * @remarks
 * This method is specifically used in focal point implementation for Media images object-position style rule
 *
 * @param obj - The focal point object
 *
 * @example
 * ```
 * const obj = {
 *  leftPercentage: 80,
 *  topPercentage: 40,
 * }
 * const objectPosition = getFocalPointObjectPosition(obj);
 * ```
 * @returns string
 */
export const getFocalPointObjectPosition = (data: FocalPoint) => {
  if (data) {
    return `${data.leftPercentage ?? 50}% ${data.topPercentage ?? 50}%`;
  }

  return '50% 50%';
};
